const AUTH_PROVIDER = (import.meta.env.VITE_AUTH_PROVIDER || "cognito").toLowerCase();

const cognitoRegion = import.meta.env.VITE_COGNITO_REGION || import.meta.env.VITE_AWS_REGION;

let config = {
  controlPlaneAPI: import.meta.env.VITE_APP_ENDPOINT || "http://localhost:8000",
  sentryEnabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
  sentryArn: import.meta.env.VITE_APP_SENTRY || "",
  marketingEnabled: import.meta.env.VITE_MARKETING_ENABLED !== "false",
};

const amplifyConfig = {
  Auth: {
    Cognito: {
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ["email", "openid", "profile"],
          redirectSignIn: ["http://localhost:5173", import.meta.env.VITE_REDIRECT_SIGN_IN],
          redirectSignOut: ["http://localhost:5173", import.meta.env.VITE_REDIRECT_SIGN_OUT],
          responseType: "code",
        },
      },
      region: cognitoRegion,
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_APP_CLIENT_ID,
    },
  },
};
export const isSentryEnabled = () => config.sentryEnabled;
export const isMarketingEnabled = () => config.marketingEnabled;

export { config, amplifyConfig };
